import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router-dom';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { detalheEmpresaSeller, cadastrarSeller, editarSeller, inativarSeller, ativarSeller } from '../../../../../services/http/sellerService'
import { trackPromise } from 'react-promise-tracker';
import services from '../../../../../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { estados, cidadesBrasil } from '../../../../../services/estadosBrasil'
import { buscarEnderecoPorCep } from '../../../../../services/http/cepService';
import { useSnackBar } from '../../../../../hooks/snackBar';
import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const FormEmpresaSeller = () => {
    const history = useHistory();
    const { addSnackBar } = useSnackBar();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const { idEmpresa } = useParams();
    const [empresaSeller, setEmpresaSeller] = useState({
        cnpj: "",
        ie: "",
        razaoSocial: "",
        nomeFantasia: "",
        tipo: "",
        ativo: false,
        endereco: {
            id: "",
            cep: "",
            logradouro: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade: "",
            estado: "",
            urlGoogleMaps: ""
        },
        telefone: {
            id: "",
            ddd: "",
            numero: ""
        }
    });

    const [cidades, setCidades] = useState([]);

    const CarregarDetalhesEmpresaSeller = () => {
        trackPromise(
            detalheEmpresaSeller(idEmpresa)
                .then(res => {
                    if (res.data) {
                        setEmpresaSeller(res.data);
                        if (res.data?.endereco?.estado != null) {
                            listarCidadesBrasil(res.data.endereco.estado);
                        }
                        else {
                            setEmpresaSeller((prevent) => ({
                                ...prevent,
                                endereco: {
                                    id: "",
                                    cep: "",
                                    logradouro: "",
                                    numero: "",
                                    complemento: "",
                                    bairro: "",
                                    cidade: "",
                                    estado: "",
                                    urlGoogleMaps: ""
                                }
                            }));
                        }
                        if (res.data?.telefone == null) {
                            setEmpresaSeller((prevent) => ({
                                ...prevent,
                                telefone: {
                                    id: "",
                                    ddd: "",
                                    numero: ""
                                }
                            }));
                        }
                    } else {
                        if (idEmpresa) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do seller', info: 'error', open: true });
                        }
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do seller', info: 'error', open: true });
                })
        )
    }

    const enderecoPorCep = (cep) => {
        trackPromise(
            buscarEnderecoPorCep(cep)
                .then(res => {
                    if (!res.fail && res.data) {
                        listarCidadesBrasil(res.data.uf.sigla);

                        console.log(res.data);

                        setEmpresaSeller((prevent) => ({
                            ...prevent,
                            endereco: {
                                cep: res.data.cep,
                                logradouro: res.data.logradouro,
                                bairro: res.data.bairro,
                                estado: res.data.uf.sigla,
                                cidade: res.data.cidade.nome
                            }
                        }));
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const listarCidadesBrasil = (uf) => {
        trackPromise(
            cidadesBrasil(uf)
                .then(res => {
                    if (res.data) {
                        setCidades(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar as cidades', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao carregar cidades', info: 'error', open: true });
                })
        )
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!empresaSeller.cnpj) isInvalidForm = true;
        if (!empresaSeller.razaoSocial) isInvalidForm = true;
        if (!empresaSeller.nomeFantasia) isInvalidForm = true;
        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const verificarTelefone = () => {
        if (empresaSeller.telefone.numero.includes("(")) {
            empresaSeller.telefone.ddd = empresaSeller.telefone.numero.substring(0, 4).replace("(", "").replace(")", "");
            empresaSeller.telefone.numero = empresaSeller.telefone.numero.substring(5, empresaSeller.telefone.lenght).replace('-', '');
        }
        //if (empresaSeller.telefone.numero.length == 11) {
        //    empresaSeller.telefone.numero = empresaSeller.telefone.numero.substring(2, empresaSeller.telefone.numero.length);
        //}
    }

    const inativarEmpresaSeller = () => {
        if (idEmpresa != undefined) {
            trackPromise(
                inativarSeller(idEmpresa)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Seller inativado com sucesso', info: 'success', open: true });
                            history.push('/admin/sellers');
                        } else {
                            addSnackBar({ message: 'Não foi possível inativar seller', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar seller', info: 'error', open: true });
                    })
            )
        }
    }

    const ativarEmpresaSeller = () => {
        if (idEmpresa != undefined) {
            trackPromise(
                ativarSeller(idEmpresa)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Seller ativado com sucesso', info: 'success', open: true });
                            history.push('/admin/sellers');
                        } else {
                            addSnackBar({ message: 'Não foi possível ativar seller', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao ativar seller', info: 'error', open: true });
                    })
            )
        }
    }

    const submitEmpresaSeller = () => {
        if (!validarForm()) {
            empresaSeller.cnpj = services.mask.unMask(empresaSeller.cnpj)
            empresaSeller.endereco.cep = services.mask.unMask(empresaSeller.endereco.cep)
            verificarTelefone();

            if (idEmpresa == undefined) {
                trackPromise(
                    cadastrarSeller(empresaSeller)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                history.push('/admin/sellers');
                                /*  setCidades(res.data); */
                            } else {
                                /*  addSnackBar({ message: 'Não foi possível cadastrar seller', info: 'error', open: true }); */
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar seller', info: 'error', open: true });
                        })
                )
            }
            else {
                empresaSeller.id = idEmpresa;
                trackPromise(
                    editarSeller(empresaSeller)
                        .then(res => {
                            if (res.fail == null) {
                                addSnackBar({ message: 'Seller atualizado com sucesso', info: 'success', open: true });
                                history.push('/admin/sellers');
                            } else {
                                /* addSnackBar({ message: 'Não foi possível cadastrar seller', info: 'error', open: true }); */
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                                /*                                 empresaSeller.telefone.numero =  empresaSeller.telefone.ddd + empresaSeller.telefone.numero; */

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar seller', info: 'error', open: true });
                        })
                )
            }

        }

        //alert(empresaSeller.telefone.numero);
        if (empresaSeller.telefone.numero.length == 9) {
            empresaSeller.telefone.numero = empresaSeller.telefone.ddd + empresaSeller.telefone.numero;
        }

    }

    useEffect(() => {
        if (idEmpresa) {
            CarregarDetalhesEmpresaSeller();
        }
    }, []);

    useEffect(() => {
        //if (empresaSeller?.telefone?.numero != "" && empresaSeller?.telefone?.numero?.length == 9) {
        //    empresaSeller.telefone.numero = empresaSeller.telefone.ddd + empresaSeller.telefone.numero;
        //}
    }, [empresaSeller]);

    const changesDadosEmpresa = (value, propertie) => {
        setEmpresaSeller((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const changesEndereco = (value, propertie,) => {
        setEmpresaSeller((prevent) => ({
            ...prevent,
            endereco: {
                ...prevent.endereco,
                [propertie]: value
            }
        }));
        if (propertie === 'estado') {
            listarCidadesBrasil(value);
        }

    }

    const changesTelefone = (value) => {
        var ddd = (value.length >= 2 ? value.substring(0, 4) : value).replace("(", "").replace(")", "");
        var numero = (value.length >= 2 ? value.substring(5, value.length) : '').replace('-', '').replace(' ', '');
        //alert(ddd);
        //alert(numero);
        //var ddd = value.substring(0, 4).replace("(", "").replace(")", "");
        //var numero = value.substring(5,value.lenght).replace('-','');
        setEmpresaSeller((prevent) => ({
            ...prevent,
            telefone: {
                ...prevent.telefone,
                numero: numero,
                ddd: ddd
            }
        }));
    }

    return (
        <div className="ml-1 mt20">
            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Dados da Empresa</strong></div></div>
            <div className="row">
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            required
                            label="CNPJ"
                            placeholder="00000000000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(services.mask.cpfCnpj(event.target.value), 'cnpj')}
                            value={services.mask.cpfCnpj(empresaSeller?.cnpj) || ''}
                            helperText={isFormInvalid && !empresaSeller?.cnpj && 'Campo obrigatório'}
                            error={isFormInvalid && !empresaSeller?.cnpj ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="IE"
                            inputProps={{ maxLength: 20 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'ie')}
                            value={empresaSeller?.ie || ''}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl >
                        <TextField
                            label="IM"
                            inputProps={{ maxLength: 20 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'im')}
                            value={empresaSeller?.im || ''}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl >
                        <TextField
                            required
                            label="Razão Social"
                            inputProps={{ maxLength: 200 }}
                            placeholder="Informe a Razão Social"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'razaoSocial')}
                            value={empresaSeller?.razaoSocial || ''}
                            helperText={isFormInvalid && !empresaSeller?.razaoSocial && 'Campo obrigatório'}
                            error={isFormInvalid && !empresaSeller?.razaoSocial ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            required
                            label="Nome Fantasia"
                            inputProps={{ maxLength: 150 }}
                            placeholder="Informe o Nome Fantasia"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesDadosEmpresa(event.target.value, 'nomeFantasia')}
                            value={empresaSeller?.nomeFantasia || ''}
                            helperText={isFormInvalid && !empresaSeller?.nomeFantasia && 'Campo obrigatório'}
                            error={isFormInvalid && !empresaSeller?.nomeFantasia ? true : false}
                        />
                    </FormControl>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3"><FormControl >
                    <TextField
                        label="Telefone"
                        placeholder="00 00000-0000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        inputProps={{ maxLength: "16" }}
                        onChange={event => changesTelefone(services.mask.phoneoucelularchange(event.target.value))}
                        value={services.mask.phoneoucelular(empresaSeller?.telefone?.ddd + empresaSeller?.telefone?.numero) || ''}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        label="CEP"
                        placeholder="00000-000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onBlur={event => enderecoPorCep(event.target.value)}
                        onChange={event => changesEndereco(services.mask.cep(event.target.value), 'cep')}
                        value={services.mask.cep(empresaSeller?.endereco?.cep) || ''}
                    />
                </FormControl></div>
                <div className="col-sm-5 col-md-5 col-lg-5"><FormControl >
                    <TextField
                        label="Logradouro"
                        inputProps={{ maxLength: 150 }}
                        placeholder="Informe o endereço"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'logradouro')}
                        value={empresaSeller?.endereco?.logradouro || ''}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        label="Número"
                        inputProps={{ maxLength: 10 }}
                        placeholder="000000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'numero')}
                        value={empresaSeller?.endereco?.numero || ''}
                    />
                </FormControl></div>
            </div>

            <div className="row">

                <div className="col-sm-4 col-md-4 col-lg-4"><FormControl >
                    <TextField
                        label="Complemento"
                        inputProps={{ maxLength: 250 }}
                        placeholder="Informe o complemento"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'complemento')}
                        value={empresaSeller?.endereco?.complemento || ''}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"> <FormControl >
                    <TextField
                        label="Bairro"
                        placeholder="Informe o Bairro"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'bairro')}
                        value={empresaSeller?.endereco?.bairro || ''}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>

                        <InputLabel id="demo-simple-select-helper-label">Estado</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            value={empresaSeller?.endereco?.estado || 'selecione'}
                            label="Estado"
                            onChange={event => changesEndereco(event.target.value, 'estado')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o estado</em>
                            </MenuItem>

                            {estados.map(es =>
                                <MenuItem value={es}>{es}</MenuItem>
                            )}
                        </Select>

                        {/*  {isFormInvalid && !empresaSeller?.endereco?.estado &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <InputLabel id="demo-simple-select-helper-label">Cidade*</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            value={empresaSeller?.endereco?.cidade.toUpperCase() || 'cidade'}
                            label="Cidade"
                            onChange={event => changesEndereco(event.target.value, 'cidade')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"cidade"}>
                                <em>Selecione sua cidade</em>
                            </MenuItem>

                            {cidades.map(cd =>
                                <MenuItem value={cd.nome.toUpperCase()}>{cd?.nome}</MenuItem>
                            )}


                        </Select>
                        {/*  {isFormInvalid && !empresaSeller?.endereco?.cidade &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <FormControl>
                        <TextField
                            label="URL Google Maps"
                            placeholder="Informe a URL"
                            type="text"
                            size="small"
                            inputProps={{ maxLength: 500 }}
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesEndereco(event.target.value, 'urlGoogleMaps')}
                            value={empresaSeller?.endereco?.urlGoogleMaps || ''}
                        />
                    </FormControl></div>
            </div>
            <div className="row">
                <div className="col-sm-5 col-md-5 col-lg-5">
                    <FormControl><InputLabel id="demo-simple-select-helper-label">Tipo</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            value={empresaSeller?.tipo || 'selecione'}
                            label="Estado"
                            onChange={event => changesDadosEmpresa(event.target.value, 'tipo')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o tipo</em>
                            </MenuItem>
                            <MenuItem value={"Industria"}>Indústria</MenuItem>
                            <MenuItem value={"Distribuidor"}>Distribuidor</MenuItem>
                            <MenuItem value={"Atacado"}>Atacado</MenuItem>

                        </Select>

                        {/* {isFormInvalid && !empresaSeller?.tipo &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
            </div>


            {idEmpresa != null &&
                <div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={() => submitEmpresaSeller()}>SALVAR</button>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => history.push('/admin/sellers')}>CANCELAR</button>
                        {empresaSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarEmpresaSeller} >INATIVAR</button>}
                        {!empresaSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarEmpresaSeller}>ATIVAR</button>}

                    </div>


                </div>}

            {idEmpresa == null &&
                <div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => history.push('/admin/sellers')}>CANCELAR</button>
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={() => submitEmpresaSeller()}>SALVAR</button>
                    </div>

                </div>}
        </div>
    )
}

export default FormEmpresaSeller;